import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { ValueCell } from "@tools";

export const PriceModifierCompanyProfitCell = observer((cellProps) => {
  
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_PROFIT }
      useDynamicWidth
      {...cellProps}
    />
  );
});